import { css } from '@emotion/react';
import { RECENT_SEARCH_WIDTH_IN_PX, RECENT_SEARCH_WIDTH_WITHOUT_ITEMS_IN_PX } from '../../ui';
export var inputWrapper = css({
  display: 'flex',
  lineHeight: 0,
  padding: "var(--ds-space-075, 6px)".concat(" 0"),
  alignItems: 'center'
});
export var container = css({
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',
  padding: 0,
  width: "".concat(RECENT_SEARCH_WIDTH_WITHOUT_ITEMS_IN_PX, "px"),
  lineHeight: 'initial'
});
export var containerWithProvider = css({
  width: "".concat(RECENT_SEARCH_WIDTH_IN_PX, "px")
});